import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class CallService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  add(data: {}): Observable<any> {
    return this.postRequest(AppUrl.CALL(), data, {success: '', failure: ''}, true);
  }

  fetchIncomingCalls(): Observable<any> {
    return this.postRequest(AppUrl.INCOMING_CALLS());
  }

  fetchOutgoingCalls(): Observable<any> {
    return this.postRequest(AppUrl.OUTGOING_CALLS());
  }

  uploadCallRecordings(): Observable<any> {
    return this.putRequest(AppUrl.UPLOAD_CALLS());
  }

  get(data: {}): Observable<any> {
    return this.getRequestWithoutErrorMessage(AppUrl.CALL(), data);
  }

  detail(uniqueId: any): Observable<any> {
    return this.getRequest(AppUrl.CALL(uniqueId));
  }

  delete(uniqueId: any): Observable<any> {
    return this.deleteRequest(AppUrl.CALL(uniqueId));
  }

  update(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.CALL(uniqueId), data);
  }

  updateCallCurrentStatus(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.CALL_CURRENT_STATUS(uniqueId), data, true);
  }

  status(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.CALL_STATUS(uniqueId), data);
  }

  count(): Observable<any> {
    return this.getRequest(AppUrl.CALL_COUNT());
  }

  recordedCalls(data: any): Observable<any> {
    return this.getRequest(AppUrl.RECORDED_CALLS(), data);
  }

  auditRecording(data: any, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.AUDIT_RECORDING(uniqueId), data);
  }
}
